import React from "react";
import getImageUrl from "../../utils/imageUtils";
import styles from "./MentionDropdown.module.css";

/**
 * MentionDropdown
 * Floating list of product suggestions triggered by `@` in a textarea.
 */
const MentionDropdown = ({ suggestions = [], query = "", onSelect }) => {
  const hasResults = suggestions.length > 0;
  const showEmpty = query.trim().length >= 1 && !hasResults;

  if (!hasResults && !showEmpty) return null;

  return (
    <div className={styles.dropdown} role="listbox" aria-label="Product suggestions">
      <div className={styles.header}>Tag a product</div>
      {hasResults ? (
        suggestions.map((product) => (
          <button
            key={product._id}
            type="button"
            role="option"
            className={styles.item}
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect(product);
            }}
          >
            {product.images?.[0] ? (
              <img
                src={getImageUrl(product.images[0])}
                alt={product.name}
                className={styles.thumb}
              />
            ) : (
              <div className={styles.thumbPlaceholder}>📦</div>
            )}
            <div className={styles.info}>
              <span className={styles.name}>{product.name}</span>
              {product.brand?.name && (
                <span className={styles.brand}>{product.brand.name}</span>
              )}
            </div>
            {product.price != null && (
              <span className={styles.price}>
                ${product.price.toLocaleString()}
              </span>
            )}
          </button>
        ))
      ) : (
        <div className={styles.emptyHint}>No products found for &quot;{query}&quot;</div>
      )}
    </div>
  );
};

export default MentionDropdown;
